<!-- 企业级-用户管理-临时用户 -->
<template>
  <div class="mainArea CSMSLog">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入接收手机号码" v-model="keyword.phone" clearable @keyup.enter.native="getSmsLog(1)"></el-input></div>
            <el-button type="primary" @click="getSmsLog(1)">搜索</el-button>
          </div>
        </div>
        <el-button type="primary" class="mt20" @click="smsDio = true">模拟短息</el-button>
        <div class="tableList mt20">
          <el-table :data="casualData" style="width: 100%" v-loading="loading">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="content" label="内容"></el-table-column>
            <el-table-column prop="receive_phone" label="接收手机号" width="200"></el-table-column>
            <el-table-column prop="send_time" label="发送时间" width="200"></el-table-column>
            <el-table-column label="状态" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.status == '0'" class="colF56">发送失败</span>
                <span v-else-if="scope.row.status == '1'" class="col67C">发送成功</span>
                <span v-else-if="scope.row.status == '2'" class="colE6A">发送中</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="smsResend(scope.$index)">重发</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>1">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :page-count="total">
          </el-pagination>
        </div>
      </div>
      
      <el-dialog title="模拟短信" :visible.sync="smsDio" width="500px">
        <div class="contDio">
          <el-form :model="smsform" ref="form" :rules="rules" label-width="90px">
            <el-form-item label="接收手机:" prop="phone">
              <el-input v-model="smsform.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="发送内容:">
              <el-input v-model="smsform.content" disabled type="textarea" :autosize="{ minRows: 4}"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="submitSend('form')">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { platformApi } from "../../../../static/js/api.js"

  export default {
    name: 'CCasualUser',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          phone:'',//手机号
        },
        
        casualData:[],//短信记录列表数据

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据
        
        loading:false,

        smsDio:false,//模拟短息弹窗
        smsform:{
          phone:'',
          content:'测试测试',
        },
        rules:{
          phone:[
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'}
          ]
        }

        
      }
    },
    mounted(){
    },
    created: async function () {
      this.smsform.content = this.$route.query.sms_template
      this.getSmsLog()
    },
    methods: {
      //提交模拟短息
      submitSend(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.sendTemp()
          } else {
            return false;
          }
        });
      },
      //模拟短息
      async sendTemp(){
        let that = this;
        const dataObj = {
          'receive_phone': that.smsform.phone,
        }
        const res = await platformApi.sendTemp(dataObj)
        if(res.meta.code == 200){
          that.getSmsLog(1)
          showToast('发送成功！')
          that.smsform.phone = ''
        }else{
          showToast(res.meta.message)
        }
      },
      //重发
      async smsResend(index){
        let that = this;
        const dataObj = {
          'id': that.casualData[index].id,
        }
        const res = await platformApi.smsResend(dataObj)
        if(res.meta.code == 200){
          that.getSmsLog(1)
          showToast('发送成功！')
        }else{
          showToast(res.meta.message)
        }
      },
      //获取短信记录列表
      async getSmsLog(curr,limits){
        let that = this;
        this.loading = true;
        const dataObj = {
          'page': curr ? curr : that.curr,
          'perPage': limits ? limits : that.page,
          'search_str': that.keyword.phone,
        }
        const res = await platformApi.getSmsLog(dataObj)
        if(res.meta.code == 200){
          
          that.casualData = res.data.list
          that.total = parseInt(res.data.pageCount)
          that.loading = false
        }else{
          that.loading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        this.getSmsLog(val)
        // console.log(`当前页: ${val}`);
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto; 
// }
.CSMSLog{
  .col67C{
    color: #67C23A;
  }
  .colE6A{
    color: #E6A23C;
  }
  .colF56{
    color: #F56C6C;
  }
  .dib{
    display:inline-block;
  }
  .mt20{
    margin-top:20px;
  }
  .flex{
    display:flex;
    align-items:center;
  }
  .fs25{
    font-size:25px;
  }
  .biosDio{
    .el-dialog__body{
      padding:10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CPlatformOperate/CSMSLog.vue